import { createSelector } from 'reselect'
import { API_URL_VISUALIZATION } from '../../../constants/apiUrls'
import pendingRequestsSelector from './pendingRequestsSelector'
import requestIsPending from './helpers/requestIsPending'

const visualizationRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_VISUALIZATION),
)

export default visualizationRequestIsPendingSelector
